import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { shouldRouteToAdminPortal } from '../../utils/authRoles';

const AdminPortalBoundary = ({ children, fallback = null }) => {
  const location = useLocation();
  const {
    user,
    profile,
    isAuthenticated,
    loading,
  } = useSelector((state) => state.auth);

  // A privileged workspace decision is made only from the trusted Rails role.
  // Until that role resolves, render neither buyer content nor admin content.
  if (loading || (isAuthenticated && !profile?.rails_profile)) {
    return fallback;
  }

  if (shouldRouteToAdminPortal(user, profile, location.pathname)) {
    return <Navigate to="/admin-mfa" replace state={{ from: location }} />;
  }

  return children;
};

export default AdminPortalBoundary;
